<template>
    <div>
        <el-table :data="logs" style="width: 100%">
            <el-table-column type="expand">
                <template slot-scope="props">

                    <table v-if="props.row.model == 'invoice'" width="100%">
                        <thead>
                        <tr>
                            <td width="20%">修订项(发票编号: {{props.row.record_id}})</td>
                            <td width="40%">修订后内容</td>
                            <td width="40%">修订前内容</td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>发票类型</td>
                            <td>
                                <template v-if="props.row.content.type || props.row.content.type === 0">
                                    <span v-html="diffAttribute(props.row.content, props.row.old_content, 'type')"></span>
                                </template>
                            </td>
                            <td>
                                <template v-if="props.row.old_content.type || props.row.old_content.type === 0">
                                    {{getTypeLabel(props.row.old_content.type)}}
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td>纳税人识别号</td>
                            <td>
                                <template v-if="props.row.content.taxpayer_id">
                                    <span v-html="diffAttribute(props.row.content, props.row.old_content, 'taxpayer_id')"></span>
                                </template>
                            </td>
                            <td>
                                <template v-if="props.row.old_content.taxpayer_id">
                                    {{props.row.old_content.taxpayer_id}}
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td>发票抬头</td>
                            <td>
                                <template v-if="props.row.content.title">
                                    <span v-html="diffAttribute(props.row.content, props.row.old_content, 'title')"></span>
                                </template>
                            </td>
                            <td>
                                <template v-if="props.row.old_content.title">
                                    {{props.row.old_content.title}}
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td>开票内容</td>
                            <td>
                                <template v-if="props.row.content.content">
                                    <span v-html="diffAttribute(props.row.content, props.row.old_content, 'content')"></span>
                                </template>
                            </td>
                            <td>
                                <template v-if="props.row.old_content.content">
                                    {{getContentLabel(props.row.old_content.content)}}
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td>开票金额</td>
                            <td>
                                <template v-if="props.row.content.total_amount">
                                    <span v-html="diffAttribute(props.row.content, props.row.old_content, 'total_amount')"></span>
                                </template>
                            </td>
                            <td>
                                <template v-if="props.row.old_content.total_amount">
                                    {{props.row.old_content.total_amount}}
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td>开票日期</td>
                            <td>
                                <template v-if="props.row.content.input_at">
                                    <span v-html="diffAttribute(props.row.content, props.row.old_content, 'input_at')"></span>
                                </template>
                            </td>
                            <td>
                                <template v-if="props.row.old_content.input_at">
                                    {{props.row.old_content.input_at}}
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td>是否开票</td>
                            <td>
                                <template v-if="props.row.content.issue && props.row.content.is_delete == 0">
                                    <span v-html="diffAttribute(props.row.content, props.row.old_content, 'issue')"></span>
                                </template>
                            </td>
                            <td>
                                <template v-if="props.row.old_content.issue">
                                    {{props.row.old_content.issue}}
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <table v-if="props.row.model == 'express'" width="100%">
                        <thead>
                            <tr>
                                <td width="20%">物流信息(物流编号: {{props.row.record_id}})</td>
                                <td width="40%">修订后内容</td>
                                <td width="40%">修订前内容</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>寄件类型</td>
                                <td>
                                    <template v-if="props.row.content.goods_type">
                                        <span v-html="getGoodsTypeLabel(props.row.content.goods_type)"></span>
                                    </template>
                                </td>
                                <td>
                                    <template v-if="props.row.old_content.goods_type">
                                        <span v-html="getGoodsTypeLabel(props.row.old_content.goods_type)"></span>
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <td>寄出日期</td>
                                <td>
                                    <template v-if="props.row.content.send_at">
                                        <span v-html="getSendAtLabel(props.row.content.send_at)"></span>
                                    </template>
                                </td>
                                <td>
                                    <template v-if="props.row.old_content.send_at">
                                        <span v-html="getSendAtLabel(props.row.old_content.send_at)"></span>
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <td>送达方式</td>
                                <td>
                                    <template v-if="props.row.content.express_content">
                                        <span v-html="getSendTypeLabel(props.row.content.send_type)"></span>
                                    </template>
                                </td>
                                <td>
                                    <template v-if="props.row.old_content.express_content">
                                        <span v-html="getSendTypeLabel(props.row.old_content.send_type)"></span>
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <td>寄件备注</td>
                                <td>
                                    <template v-if="props.row.content.express_content">
                                        <span v-html="diffAttribute(props.row.content, props.row.old_content, 'express_content')"></span>
                                    </template>
                                </td>
                                <td>
                                    <template v-if="props.row.old_content.express_content">
                                        {{props.row.old_content.express_content}}
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <td>寄件方式</td>
                                <td>
                                    <template v-if="props.row.content.express_way">
                                        <span v-html="diffAttribute(props.row.content, props.row.old_content, 'express_way')"></span>
                                    </template>
                                </td>
                                <td>
                                    <template v-if="props.row.old_content.express_way">
                                        {{getExpressTypeLabel(props.row.old_content.express_way)}}
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <td>快递单号</td>
                                <td>
                                    <template v-if="props.row.content.express_no">
                                        <span v-html="diffAttribute(props.row.content, props.row.old_content, 'express_no')"></span>
                                    </template>
                                </td>
                                <td>
                                    <template v-if="props.row.old_content.express_no">
                                        {{props.row.old_content.express_no}}
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <td>签收状态</td>
                                <td>
                                    <template v-if="props.row.content.id">
                                        <span v-html="diffAttribute(props.row.content, props.row.old_content, 'express_status')"></span>
                                    </template>
                                </td>
                                <td>
                                    <template v-if="props.row.old_content.id">
                                        {{getExpressStatusLabel(props.row.old_content.express_status)}}
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </template>
            </el-table-column>
            <el-table-column label="操作人" prop="username"></el-table-column>
            <el-table-column label="操作时间" prop="created_at"></el-table-column>
            <el-table-column label="操作类型">
                <template slot-scope="scope">
                    {{scope.row.action_label}} {{scope.row.model_label}}
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="logLinkPage">
            <br/>
            <log-pagination :linkPage="logLinkPage" :enableEvent="true" @change="watchLogsPageChange"></log-pagination>
        </el-row>
    </div>
</template>

<script>

    import OrderService from "~/services/order";
    import LogPagination from "~/widgets/Pagination.vue";

    export default {
        name: "OrderChangeLog",
        data() {
            return {
                logs: [],
                logLinkPage: null,
                searchModel: {
                    page: 1,
                    perPage: 20,
                    order_id: ''
                }
            };
        },
        components: {
            LogPagination,
        },
        // 外部传入的客户ID
        props: {
            orderId: {
                type: Number,
                default: 0,
                required: true
            }
        },
        created() {
            if (this.orderId > 0) {
                this.searchModel.order_id = this.orderId;
                this.getOrderChangeLogs(this.searchModel);
            }
        },
        methods: {

            getTypeLabel(type) {
                // 确保type是字符串格式进行比较
                const typeStr = String(type);
                let types = {
                    '1': '普通',
                    '2': '专票',
                    '3': '电票',
                    '4': '电票'
                };

                if (types[typeStr]) {
                    return types[typeStr];
                }

                return type || ''; // 如果没有匹配则返回原始值
            },

            getContentLabel($key) {
                let invoiceTypes = OrderService.invoiceTypes();
                let value = '';
                // 确保$key是字符串类型进行比较
                const keyStr = String($key);
                
                invoiceTypes.forEach((val, key) => {
                    if (keyStr === String(val.value)) {
                        value = val.label;
                    }
                })

                return value || $key; // 如果没找到则返回原始值
            },

            getExpressTypeLabel(type) {
                let types = OrderService.options();
                let value = '';

                types.forEach((val, key) => {
                    if (type == val.value) {
                        value = val.label;
                    }
                });

                return value;
            },

            getExpressStatusLabel(status) {
                let list = {
                    0: '未签收',
                    1: '已签收'
                };

                if (list[status]) {
                    return list[status];
                }

                return '';
            },

            getSendTypeLabel(value) {
                let list = {
                    1: '快递',
                    2: '邮件'
                };

                if (list[value]) {
                    return list[value];
                }

                return '';
            },

            getGoodsTypeLabel(value) {
                let list = {
                    1: '合同',
                    2: '发票',
                    3: '报销资料',
                    4: '礼品',
                    5: '其他',
                };
                let goods_types = [];
                let arr = value.split(",");
                arr.forEach((val, key) => {
                    if (list[val]) {
                        goods_types.push(list[val]);
                    }
                });
                return goods_types.join();
            },

            getSendAtLabel(value) {
                // 将秒级时间戳转换为毫秒级时间戳
                const timestampInMilliseconds = value * 1000;

                // 创建一个 Date 对象
                const date = new Date(timestampInMilliseconds);

                // 提取年、月和日
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
                const day = String(date.getDate()).padStart(2, '0');

                // 拼接成 "yyyy-MM-dd" 格式的日期字符串
                const formattedDate = `${year}-${month}-${day}`;

                return formattedDate;
            },


            diffAttribute($content, $oldContent, $field) {
                let attribute = '';
                let oldAttribute = '';

                let value = '';

                if ($content[$field] || $content[$field] == 0) {
                    attribute = $content[$field] + '';
                }

                if ($oldContent[$field] || $oldContent[$field] == 0) {
                    oldAttribute = $oldContent[$field] + '';
                }

                switch ($field) {
                    case 'type':
                        value = this.getTypeLabel(attribute);
                        break;
                    case 'content':
                        value = this.getContentLabel(attribute);
                        break;
                    case 'express_way':
                        value = this.getExpressTypeLabel(attribute);
                        break;
                    case 'express_status':
                        value = this.getExpressStatusLabel(attribute);
                        break;
                    case 'input_at':
                        // console.log(attribute, 'attribute');
                        // console.log(oldAttribute, 'oldAttribute');
                        break;

                }

                if (attribute != oldAttribute) {
                    if (value != '') {
                        return '<i style="color: #F56C6C;">' + value + '</i>\n';
                    }

                    return '<i style="color: #F56C6C;">' + attribute + '</i>\n';
                }

                if (value != '') {
                    return value;
                }

                return attribute;
            },

            /**
             * 监听分页改变事件
             * @param pageParams
             */
            watchLogsPageChange(pageParams) {
                this.searchModel['page'] = pageParams["page"];
                this.searchModel['perPage'] = pageParams["perPage"];
                this.getOrderChangeLogs(this.searchModel);
            },

            getOrderChangeLogs(params) {
                OrderService.getOrderChangeLogs(params).then(res => {
                    if (res.data && res.data.length > 0) {
                        this.logs = res.data;
                        if (res._meta) {
                            this.logLinkPage = res._meta;
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/recoder/OrderChangeLog.vue